import axios from 'axios';
import Cryptr from 'cryptr';
import actions from 'redux/actions';
import Timer from 'helpers/setTimer';
import { SecurityConst } from 'consts/data';
import {
  handleBodyRequestCommon,
  isDefineValueOr,
  isDevelopment,
  IsJsonString,
  isLocalhost,
} from 'helpers';
import SlackService from './SlackService';
import get from 'lodash/get';
import isString from 'lodash/isString';
import userServices from './userServices';
import { AppRoutes } from 'consts/routesPath';

const { logout } = actions;

const timerSendError = new Timer();
const messageTokenExpired = 'Token expired!';

class Services {
  constructor() {
    // axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
    this.cryptr = new Cryptr('secret_key');
    this.axios = axios.create({
      baseURL: isLocalhost ? '/dev' : '',
    });
    this.interceptors = null;
    this.axios.defaults.withCredentials = true;
    this.source = axios.CancelToken.source();
    this.expired = false;
  }

  setupInterceptors(store) {
    //* Process when unauthorize
    this.axios.interceptors.response.use(
      (response) => {
        if (response?.data === 'Unauthorized') {
          if (!this.expired) {
            this.expired = true;
            store && store.dispatch(logout());
            return Promise.reject(messageTokenExpired);
          }

          return Promise.reject({ ignoreShowMessage: true });
        }

        if (!!response?.data?.error) {
          return Promise.reject(response?.data?.error);
        }

        return response;
      },
      (error) => {
        const { status } = error?.response || {};
        const pathAPI = error?.config?.url || '';
        const isLoginURL = pathAPI.includes('/login');

        if (status === 401) {
          const errorParsed =
            IsJsonString(get(error, 'response.data.body')) &&
            JSON.parse(get(error, 'response.data.body'));
          const jwtTokenForReset = get(errorParsed, 'jwtToken');
          const shouldResetPassword = !!jwtTokenForReset;

          if (shouldResetPassword) {
            if (window.location.pathname !== AppRoutes.ResetPassword) {
              userServices.clearUserCached();
              window.location.href = `${AppRoutes.ResetPassword}?token=${jwtTokenForReset}&required=true`;
            }

            return Promise.reject(error);
          }

          if (!this.expired && !isLoginURL) {
            //* Prevent logout is multi called
            this.expired = true;
            store && store.dispatch(logout());
            return Promise.reject(messageTokenExpired);
          }

          return Promise.reject({ ignoreShowMessage: true });
        }

        if (status === 400 && !isDevelopment) {
          const pathAPI = error?.config?.url || '';
          const isLoginURL = pathAPI.includes('/login');

          const username = store?.getState()?.userReducer?.data?.username || '';

          if (!isLoginURL) {
            timerSendError.debounce(() => {
              SlackService.sendError({
                title: `${error?.message || ''} - ${
                  error?.config?.url || ''
                } - account: ${username} - env: ${
                  process.env.NODE_ENV
                } - version: ${sessionStorage.getItem('version')}`,
                message: JSON.stringify({
                  requestBodyAPI: error?.response?.config?.data || '',
                  response: error?.response?.data || '',
                }),
              });
            }, 200);
          }
        }

        return Promise.reject(error);
      },
    );
  }

  encrypt(str) {
    return this.cryptr.cryptr(str);
  }

  decrypt(str) {
    return this.cryptr.decrypt(str);
  }

  getLocalStorage() {
    const data = window.localStorage.getItem(SecurityConst.authStorage);
    if (typeof data === 'object' && data === null) {
      return {};
    }

    return JSON.parse(data);
  }

  saveLocalStorage(data) {
    const { role, name, token } = data;
    const encryptedString = this.cryptr.encrypt(token);
    const dataSave = {
      role,
      name,
      token: encryptedString,
    };
    window.localStorage.setItem('user', JSON.stringify(dataSave));
  }

  clearLocalStorage() {
    window.localStorage.removeItem('user');
  }

  decryptToSessionId(obj) {
    const { name, role, token } = obj;
    if (name && role && token) {
      return `${name}(=+${role}(=+${token}`;
    }
    return '';
  }

  attactTokenStripeToHeader(token) {
    this.interceptors = this.axios.interceptors.request.use(
      function (config) {
        // Do something before request is sent
        config.headers['Authorization'] = `Bearer ${token}`;
        return config;
      },
      function (error) {
        return Promise.reject(error);
      },
    );
  }

  attachTokenToHeader(token) {
    this.interceptors = this.axios.interceptors.request.use(
      function (config) {
        // Do something before request is sent
        config.headers.sessionId = token;
        return config;
      },
      function (error) {
        return Promise.reject(error);
      },
    );
  }

  removeInterceptors() {
    this.axios.interceptors.request.eject(this.interceptors);
  }

  sourceToken() {
    return this.source.token;
  }

  get(...arg) {
    return this.axios.get(...arg);
  }

  post(url, body, config) {
    return this.axios.post(url, handleBodyRequestCommon(body), config);
  }

  delete(url, config) {
    return this.axios.delete(url, config);
  }

  put(url, body, config) {
    return this.axios.put(url, handleBodyRequestCommon(body), config);
  }

  setCookie(newCookie = '') {
    document.cookie = newCookie;
  }
}

export const HeaderUTF8Option = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
  },
};
export const ResponseTypeBlob = {
  responseType: 'blob',
};
export default new Services();
